import React, { ElementType, Fragment, useRef } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';
interface SplitTextProps {
  text: string;
  as?: 'h1' | 'h2' | 'h3' | 'p';
  className?: string;
  variant?: 'default' | 'header';
  delay?: number;
}

// Recreates the original SplitType "words slide up" reveal. Use "\n" for hard line breaks.
export function SplitText({
  text,
  as = 'h2',
  className = '',
  variant = 'default',
  delay = 0
}: SplitTextProps) {
  const ref = useRef<HTMLElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '0px 0px -5% 0px'
  });
  const reduceMotion = useReducedMotion();
  const Tag = as as ElementType;
  const lines = text.split('\n');
  const totalWords = lines.reduce((sum, line) => sum + line.split(' ').length, 0);
  const isHeader = variant === 'header';
  const staggerAmount = isHeader ? 0.75 : 0.5;
  const step = totalWords > 1 ? staggerAmount / (totalWords - 1) : 0;
  let wordIndex = 0;
  return <Tag ref={ref} className={className} aria-label={text.replace(/\n/g, ' ')} data-id="element-194" data-mp="1pwzcg5vllvlx">
      {lines.map((line, lineIndex) => <Fragment key={lineIndex} data-id="element-195" data-mp="87kitpe7r779" data-mpi={lineIndex}>
          {line.split(' ').map((word, i) => {
        const index = wordIndex++;
        return <Fragment key={`${lineIndex}-${i}`} data-id="element-196" data-mp="lxwe1x63hm2m" data-mpi={i}>
                <span aria-hidden="true" className="-mb-[0.1em] inline-block overflow-hidden pb-[0.1em] align-top" data-id="element-197" data-mp="hxce6lu504cs">
                  <motion.span className="inline-block" initial={reduceMotion ? false : {
              y: '100%',
              opacity: isHeader ? 1 : 0
            }} animate={inView || reduceMotion ? {
              y: '0%',
              opacity: 1
            } : undefined} transition={{
              duration: isHeader ? 0.9 : 0.5,
              ease: isHeader ? [0.23, 1, 0.32, 1] : [0.25, 1, 0.5, 1],
              delay: delay + index * step
            }} data-id="element-198" data-mp="3qcnqnhvkdxbd">
                    {word}
                  </motion.span>
                </span>{' '}
              </Fragment>;
      })}
          {lineIndex < lines.length - 1 && <br data-id="element-199" data-mp="c9ynlpv680dy" />}
        </Fragment>)}
    </Tag>;
}